import React, {ReactNode} from 'react';
import {ClientContextProvider, createClient} from 'react-fetching-library';
import {useAlertDispatcherState} from './AlertProvider/AlertProvider';
import {useAuthDispatch} from './AuthProvider/AuthProvider';
import {addAlert} from './AlertProvider/AlertProviderActions';
import {logout} from './AuthProvider/AuthProviderActions';
import {BasicResponse} from '../Actions/Domain';
import { Buffer } from 'buffer';

interface ViewProps {
    children?: ReactNode | undefined
}

export const ResponseFetchInterceptor : React.FunctionComponent<ViewProps> = (props)=>{
    global.Buffer = global.Buffer || Buffer;

    const alertDispatch = useAlertDispatcherState();
    const authDispatch = useAuthDispatch();

    const responseInterceptor = React.useCallback( _client => async (action, response) => {
        if( response.status === 401 ){
            addAlert(
                'Tiempo de sesion agotado',
                'El tiempo de sesión se restablece despues de un tiempo de inactividad. Es necesario hacer login nuevamente',
                'info', alertDispatch
            );

            logout(authDispatch).then();
        }


        if( response.payload ){
            const payload : BasicResponse = response.payload;
            if( payload.error && payload.error['has-error'] ){
                addAlert(
                    'Error al efectuar la petición', payload.error.error, 'error', alertDispatch
                );
            }
        }

        return response;
    }, [alertDispatch, authDispatch] );


    const Client2 = createClient({
        responseInterceptors: [responseInterceptor]
    });

    return (
        <ClientContextProvider client={Client2}>
            {props.children}
        </ClientContextProvider>
    );
};
